import ENV from '@/environment';

import { isTest } from '@/utils/environment';

import { CHAIN_IDS, SUPPORTED_CHAINS_BY_CHAIN_ID } from './chain';

const ALCHEMY_MAINNET_RPC_KEY = isTest ? ENV.ALCHEMY_INTEGRATION_TEST_API_KEY : ENV.ALCHEMY_RPC_KEY;

// supported chains RPC endpoints
export const JSON_RPC_URL_MAINNET_HTTP = `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_MAINNET_RPC_KEY}`;
export const JSON_RPC_URL_MATIC_HTTP = `https://polygon-mainnet.g.alchemy.com/v2/${ALCHEMY_MAINNET_RPC_KEY}`;
export const JSON_RPC_URL_OPTIMISM_HTTP = `https://opt-mainnet.g.alchemy.com/v2/${ALCHEMY_MAINNET_RPC_KEY}`;
export const JSON_RPC_URL_ARBITRUM_HTTP = `https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_MAINNET_RPC_KEY}`;
export const JSON_RPC_URL_AVAX_HTTP = ENV.QUICKNODE_AVAX_RPC_URL;
export const JSON_RPC_URL_BASE_HTTP = ENV.QUICKNODE_BASE_RPC_URL;
export const JSON_RPC_URL_BSC_HTTP = ENV.QUICKNODE_BSC_RPC_URL;
export const JSON_RPC_URL_SCROLL_HTTP = ENV.QUICKNODE_SCROLL_RPC_URL;

export const JSON_RPC_HTTP_URL_BY_CHAIN_ID: Record<
  keyof typeof SUPPORTED_CHAINS_BY_CHAIN_ID,
  string
> = {
  [CHAIN_IDS.MAINNET]: JSON_RPC_URL_MAINNET_HTTP,
  [CHAIN_IDS.ARBITRUM]: JSON_RPC_URL_ARBITRUM_HTTP,
  [CHAIN_IDS.AVALANCHE]: JSON_RPC_URL_AVAX_HTTP,
  [CHAIN_IDS.BASE]: JSON_RPC_URL_BASE_HTTP,
  [CHAIN_IDS.BSC]: JSON_RPC_URL_BSC_HTTP,
  [CHAIN_IDS.MATIC]: JSON_RPC_URL_MATIC_HTTP,
  [CHAIN_IDS.OPTIMISM]: JSON_RPC_URL_OPTIMISM_HTTP,
  [CHAIN_IDS.SCROLL]: JSON_RPC_URL_SCROLL_HTTP,
};

// default refresh interval for getting price & chart data in milliseconds
export const REFRESH_INTERVAL = 30_000;
